<template>
  <ModalPlayerLayout :closeModal="closeInfosModal">
    <div class="video-info-container">
      <div id="genral-information" v-if="information.primary && Object.keys(information.primary).length > 0">
        <div class="general-info-title">{{ $t('AllTraslation.globalInfo') }}</div>
        <div class="general-info-wrapper b-b">
          <div class="thumbnail-container" v-if="this.getSkinInfos.info_thumbnail">
            <img class="img-fluid" v-if="posterInformation" :src="posterInformation" alt="video_img" />
            <div v-else class="img-fluid" v-html="posterInformation">
            </div>
          </div>
          <MainInfo :mediaId="mediaId" :information="information" :mediaType="mediaType" />


        </div>

        <div class="description b-b" v-if="this.getSkinInfos.info_desc" v-show="information.primary.description">

          {{ information.primary.description }}

        </div>
        <div class="b-b" v-show="information.chapters.length > 0 && this.getSkinInfos.info_chapters ">
          <Chapters :information="information" :chapters="(information.chapters.filter((ch) => ch.title))" :player="player">
          </Chapters>
        </div>
        <div class="b-b" v-show="information.files.length > 0 && this.getSkinInfos.info_files ">
          <Files :information="information" :files="(information.files)" :player="player"></Files>
        </div>
        <div v-if="copyRight && this.getSkinInfos.info_copyright" class="b-b">
          ©️ {{ copyRight }}
        </div>
      </div>
    </div>
  </ModalPlayerLayout>
</template>

<script >
import MainInfo from './Sections/MainInfo/MainInfo.vue';
import Chapters from './Sections/Chapters/ChaptersSection.vue';
import Files from './Sections/Files/FilesSection.vue'
import en from '../../../i18n/en_US'
import fr from '../../../i18n/fr_FR'
import { mapGetters } from "vuex";
import ModalPlayerLayout from '../../layout/ModalPlayerLayout/ModalPlayerLayout.vue';
import { SVG } from "./../../utils/const"
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'video-information',
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  components: {
    ModalPlayerLayout,
    MainInfo,
    Chapters,
    Files
  },
  props: {
    information: {
      type: Object,
      required: true,
    },
    player: {
      type: Object,
      required: true,
    },
    mediaId: {
      type: Number,
      required: true,
    },
    statsParams: {
      type: Object,
      required: true,
    },
    mediaType: {
      type: String,
    },
    copyRight: {
      type: String
    },
    isBo: {
      type: Boolean
    },
    isChapters: {
      type: Boolean
    },
    poster: {
      type: String,
    },
    closeInfosModal: {
      type: Function
    }
  },
  data() {
    return {
      isOpen: false,
      isMoreEmbedParamsVisible: false,
      isAttachedFilesVisible: true,
      isAuthorSheetVisible: false,
      isLinksVisible: true,
      isChaptersVisible: true,
      isDescriptionVisible: false,
      exportOpts: {
        embedUrl: this.information?.exportOptions.embedCode,
        isAutoplay: false,
        color: '#E64444',
        startAt: {
          s: 0,
          m: 0,
          h: 0,
        },
        iframeUrl: '',
      },
      moreInfoBtnVisible: true,
      colors: { hex: '#E64444' },
      displayPicker: false,
      stats: true,
      nb_stats_views: 0,
      lang: 'fr',
      posterInformation: this.poster ? this.poster : SVG.NO_IMAGE_SVG,
      errorImg: false,
      queries: {}
    };
  },


  methods: {
    toggleVisibility(prop) {
      switch (prop) {
        case 'description':
          this.isDescriptionVisible = !this.isDescriptionVisible;
          break;
        default:
      }
    },
  },
    computed: {
    ...mapGetters(["getSkinInfos"]),

  },
});
</script>

<style>
@import './InfosModal.css';
</style>
